module.exports = "<div class=\"sd-translation-line-skeleton\">\r\n</div>\r\n";